import { makeInflect } from "../../../../core/utils/makeInflect.js";

export const inflectMacaroons = makeInflect("makronka", "makronky", "makronek");
